<ng-container [ngSwitch]="state">
  <ng-container *ngSwitchCase="AuthStatesEnum.FORGOTPWD">
    <app-forgotten-pasword></app-forgotten-pasword>
  </ng-container>
  <ng-container *ngSwitchCase="AuthStatesEnum.FIRSTCONNECT">
    <app-forgotten-pasword></app-forgotten-pasword>
  </ng-container>
  <ng-container *ngSwitchCase="AuthStatesEnum.RESETPWD">
    <app-reset-password-form></app-reset-password-form>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <app-login-form></app-login-form>
  </ng-container>
</ng-container>
